// src/pages/HomePage.tsx
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import AwardsSection from '../components/AwardsSection';
import TechnologySection from '../components/TechnologySection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { buildCanonicalUrl, buildOgImageUrl } from '../utils/seo';

const { Content } = Layout;

const HomePage = () => {
  const { t } = useTranslation();
  const canonicalUrl = buildCanonicalUrl('/');
  const homeJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'AIlicorn',
      url: canonicalUrl,
      inLanguage: ['en', 'zh-TW'],
      publisher: {
        '@type': 'Organization',
        name: 'AIlicorn',
        logo: buildOgImageUrl('/logo.png'),
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: t('seo.home.title'),
      description: t('seo.home.description'),
      url: canonicalUrl,
      inLanguage: ['en', 'zh-TW'],
      about: [
        'AI fall detection',
        'millimeter-wave sensing',
        'contactless vital sign monitoring',
        'smart building safety',
        'senior care safety',
      ],
      mainEntity: {
        '@type': 'Service',
        name: t('hero.title'),
        serviceType: 'AI fall detection and contactless sensing',
        description: t('hero.description'),
        provider: {
          '@type': 'Organization',
          name: 'AIlicorn',
        },
        areaServed: 'TW',
      },
    },
    {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AIlicorn',
    url: canonicalUrl,
    logo: buildOgImageUrl('/logo.png'),
    description: t('seo.home.description'),
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        email: 'service@ailicorn.com',
        availableLanguage: ['en', 'zh-TW'],
      },
    ],
    sameAs: ['https://www.linkedin.com/company/ailicorn-inc'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: t('awards.title'),
      itemListElement: [
        { key: 'meet_taipei', descriptionKey: 'subtitle' },
        { key: 'ces', descriptionKey: 'subtitle' },
        { key: 'fiti', descriptionKey: 'category' },
        { key: 'innoserve', descriptionKey: 'category' },
        { key: 'csmu', descriptionKey: 'category' },
        { key: 'cht5g', descriptionKey: 'category' },
      ].map((award, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Thing',
          additionalType: 'https://schema.org/award',
          name: t(`awards.items.${award.key}.title`),
          description: t(`awards.items.${award.key}.${award.descriptionKey}`),
        },
      })),
    },
  ];

  return (
    <Layout className="homepage-layout">
      <SEO
        title={t('seo.home.title')}
        description={t('seo.home.description')}
        keywords={t('seo.home.keywords')}
        ogImage={buildOgImageUrl('/logo.png')}
        ogUrl={canonicalUrl}
        canonical={canonicalUrl}
        jsonLd={homeJsonLd}
      />
      <Content>
        <HeroSection />
        <FeaturesSection />
        <AwardsSection />
        <TechnologySection />
      </Content>
      <Footer />
    </Layout>
  );
};

export default HomePage;
